import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAxiosUnauthorizedInterceptor } from '@hooks/useAxiosUnauthorizedInterceptor';
import { useKeyboardShortcuts } from '@hooks/useKeyboardShortcuts';


const AxiosInterceptor = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useKeyboardShortcuts(navigate);
    useAxiosUnauthorizedInterceptor(dispatch);

    return null;
};

export default AxiosInterceptor;